import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export const getSiteUnits = async (siteId, options = { onlyIds: false }) => {
  const endpoint = `${apiEndpoints.sites}/${siteId}/machines?onlyIds=${options.onlyIds}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
